import { post } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';
import { ALERT_QUERY_KEYS } from 'app/modules/alerts/queries/keys';
import { AlertHitsResponse } from 'app/modules/alerts/types/responses';
import { useSelector } from 'react-redux';
import { selectHasReadAlertsPermission } from 'app/modules/session/selectors';

const fetchAlertHits = (
  alertId: number,
  offset: number,
  limit: number,
): Promise<AlertHitsResponse> => {
  const path = `/v1/alerts/${alertId}/hits`;
  return post(path, { offset, limit });
};

export const useFetchAlertHits = (
  alertId: number | null,
  page: number,
  pageSize: number,
  enabled: boolean = true,
) => {
  const hasReadAlertsPermission = useSelector(selectHasReadAlertsPermission);
  return useQuery({
    queryKey: ALERT_QUERY_KEYS.getAlertHits(alertId!, page, pageSize),
    queryFn: () => fetchAlertHits(alertId!, page, pageSize),
    enabled: !!alertId && hasReadAlertsPermission && enabled,
  });
};
